export default "__VITE_ASSET__9xkUaSqJ__"